import {
  GET_REMINDER,
  GET_REMINDER_SUCCESS,
  GET_REMINDER_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getReminderReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REMINDER:
      return { ...state, loading: true };
    case GET_REMINDER_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_REMINDER_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getReminderReducer;
